
import { Placement } from '@post-office/placements-frontend/projects-app-changeboarding';
export default Placement;
